import { LoaderFunction, redirect } from "react-router-dom";
import { RootState } from "../../store/store";
import { store } from "../../store/store";
import { ROUTES } from "../../utils/constants";
import { verifyUserTokens } from "../../models/authSlice";
import {
  isAllowedBillAuditReturnUrl,
  syncSessionCookieFromStorage,
} from "../../utils/sessionCookie";

export const loginLoader: LoaderFunction = async ({ request }) => {
  await store.dispatch(verifyUserTokens());
  syncSessionCookieFromStorage();

  const state: RootState = store.getState();
  const url = new URL(request.url);
  const returnUrl = url.searchParams.get("returnUrl");

  if (state.auth.isAuthenticated) {
    if (returnUrl && isAllowedBillAuditReturnUrl(returnUrl)) {
      return redirect(returnUrl);
    }
    return redirect(ROUTES.CLAIMS_LIST);
  }
  return null;
};
